"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_1 = require("date-fns");
const _1 = require(".");
const cargo_1 = require("../cargo");
const claimCompleted_1 = __importDefault(require("./claimCompleted"));
const claimDetails_1 = __importDefault(require("./claimDetails"));
const claimDocuments_1 = __importDefault(require("./claimDocuments"));
const contact_1 = __importDefault(require("../contact"));
const certificate_1 = __importDefault(require("../certificate"));
class InsuranceClaim extends certificate_1.default {
    constructor(partner, certificateNumber, purchasedDate, user, coverage, assured, shipment, payment, partnerIds, authorizedUsers, channel, sandbox, step, details, documents, contact, completed, claimStatus, claimPayment, sendEmailTo, threshold, wkwReference, errorWebster, claimSubmittedDate, version, claimNumber, googleDriveURL) {
        super(partner, certificateNumber, purchasedDate, user, coverage, assured, shipment, payment, partnerIds, authorizedUsers, channel, sandbox);
        this.step = step;
        this.details = details;
        this.documents = documents;
        this.contact = contact;
        this.completed = completed;
        this.claimStatus = claimStatus;
        this.claimPayment = claimPayment;
        this.sendEmailTo = sendEmailTo;
        this.threshold = threshold;
        this.wkwReference = wkwReference;
        this.errorWebster = errorWebster;
        this.claimSubmittedDate = claimSubmittedDate;
        this.version = version;
        this.claimNumber = claimNumber;
        this.googleDriveURL = googleDriveURL;
        this.applicableFreightCostsAndCharges = this.applicableAdditionalCharges();
        this.applicableAllowanceForAdditionalCosts =
            this.getApplicableAllowanceForAdditionalCosts();
        this.relatedInsuranceCosts = this.applicableInsuranceCosts();
        this.totalClaimAmount = this.getTotalClaimAmount();
        this.totalLoss = this.getTotalLoss();
    }
    static fromObj(data) {
        var _a, _b, _c, _d;
        const certificate = certificate_1.default.fromObj(data);
        return new InsuranceClaim(certificate.partner, certificate.certificateNumber, certificate.purchasedDate, certificate.user, certificate.coverage, certificate.assured, certificate.shipment, certificate.payment, certificate.partnerIds, certificate.authorizedUsers, certificate.channel, certificate.sandbox, data.step || 1, claimDetails_1.default.fromObj(data.details), claimDocuments_1.default.fromObj(data.documents), contact_1.default.fromObj(data.contact), claimCompleted_1.default.fromObj(data.completed), (_a = data.claimStatus) !== null && _a !== void 0 ? _a : data.DRAFT, (_b = data.claimPayment) !== null && _b !== void 0 ? _b : {}, (_c = data.sendEmailTo) !== null && _c !== void 0 ? _c : [], data.threshold, data.wkwReference, data.errorWebster, (_d = data.claimSubmittedDate) !== null && _d !== void 0 ? _d : undefined, data.version || certificate.version, data.claimNumber, data.gDriveURL);
    }
    isDraft() {
        return this.claimStatus === _1.eClaimStatus.DRAFT;
    }
    invoiceValue() {
        return this.details.invoiceValue > 0 ? this.details.invoiceValue : 0;
    }
    requestedClaimValue() {
        var _a;
        const requestedClaim = (_a = this.details.requestedClaimValue) !== null && _a !== void 0 ? _a : 0;
        if (requestedClaim > 0) {
            return requestedClaim;
        }
        return 0;
    }
    additionalCharges() {
        return this.details.additionalCharges > 0
            ? this.details.additionalCharges
            : 0;
    }
    claimPercentage() {
        var _a;
        return this.invoiceValue()
            ? ((_a = this.requestedClaimValue()) !== null && _a !== void 0 ? _a : 0) / this.invoiceValue()
            : 0;
    }
    insuranceCosts() {
        return this.coverage.premium;
    }
    deductible() {
        return this.coverage.deductible;
    }
    applicableInsuranceCosts() {
        return this.insuranceCosts() * this.claimPercentage();
    }
    applicableAdditionalCharges() {
        return this.details.additionalCharges * this.claimPercentage();
    }
    allowanceForAdditionalCosts() {
        var _a;
        if (((_a = this.shipment.cargo) === null || _a === void 0 ? void 0 : _a.truckload) === cargo_1.eTruckloadType.LTL) {
            return 0;
        }
        const cifValue = this.invoiceValue() + this.additionalCharges() + this.insuranceCosts();
        return cifValue * 0.1;
    }
    getApplicableAllowanceForAdditionalCosts() {
        return this.allowanceForAdditionalCosts() * this.claimPercentage();
    }
    getTotalLoss() {
        return (this.requestedClaimValue() +
            this.applicableInsuranceCosts() +
            this.applicableAdditionalCharges() +
            this.getApplicableAllowanceForAdditionalCosts());
    }
    getTotalClaimAmount() {
        return this.getTotalLoss() - this.deductible();
    }
    claimExceedsDeductible() {
        return this.getTotalClaimAmount() > 0;
    }
    setUser(user) {
        this.user = user;
        if (!this.authorizedUsers.includes(user.email)) {
            this.authorizedUsers.push(user.email);
        }
    }
    static isValidLossDate(lossDate, pickupDate, deliveryDate, daysRange) {
        const lossDateStart = date_fns_1.startOfDay(date_fns_1.parseISO(lossDate));
        const formattedPickupDate = date_fns_1.startOfDay(pickupDate);
        const timelapse = date_fns_1.addDays(deliveryDate, daysRange);
        const timelapseEnd = date_fns_1.endOfDay(timelapse);
        return ((!date_fns_1.isBefore(lossDateStart, formattedPickupDate) &&
            !date_fns_1.isAfter(lossDateStart, timelapseEnd)) ||
            date_fns_1.isEqual(lossDateStart, formattedPickupDate));
    }
}
exports.default = InsuranceClaim;
//# sourceMappingURL=insuranceClaim.class.js.map